export const TEMP_NOTES = [
    {
        id: 1,
        title: 'Note 1',
        description: 'This is long long description of note 1',
        isArchived: false,
        isPinned: false,
    },
    {
        id: 2,
        title: 'Note 2',
        description: 'This is long long description of note 2',
        isArchived: false,
        isPinned: false,
    },
    {
        id: 3,
        title: 'Note 3',
        description: 'This is long long description of note 3',
        isArchived: false,
        isPinned: false,
    },
    {
        id: 4,
        title: 'Note 4',
        description: 'This is long long description of note 4',
        isArchived: false,
        isPinned: false,
    },
    {
        id: 5,
        title: 'Note 5',
        description: 'This is long long description of note 5',
        isArchived: false,
        isPinned: false,
    },
    {
        id: 6,
        title: 'Note 6',
        description: 'This is long long description of note 6',
        isArchived: false,
        isPinned: false,
    },
    {
        id: 7,
        title: 'Note 7',
        description: 'This is long long description of note 7',
        isArchived: true,
        isPinned: false,
    },
    {
        id: 8,
        title: 'Note 8',
        description: 'This is long long description of note 8',
        isArchived: true,
        isPinned: false,
    },
];

